import React from "react";
import middleware from "./middlewares/middleware";
import AllTypeDiscount from "../component/sections/discount/AllTypeDiscount";
import AllDiscountCampaignBanner from "../component/sections/discount/campaign-banner/AllDiscount";
import AddDiscountCampaignBanner from "../component/sections/discount/campaign-banner/AddDiscount";
import EditDiscountCampaignBanner from "../component/sections/discount/campaign-banner/EditDiscount";
import ViewDiscountCampaignBanner from "../component/sections/discount/campaign-banner/ViewDiscountCampaignBanner";
import SelectPositionBanner from "../component/sections/discount/position-banner/SelectPositionBanner";
import AddDiscountToPositionBanner from "../component/sections/discount/position-banner/AddDiscountToPositionBanner";
import EditDiscountToPositionBanner from "../component/sections/discount/position-banner/EditDiscountToPositionBanner";

const discountRoutes = [
  {
    path: "/manage/discount/all-type",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllTypeDiscount />,
        "AllTypeDiscount"
      );
    },
    exact: true,
  },
  {
    path: "/manage/discount/campaign-banner/all",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllDiscountCampaignBanner />,
        "AllDiscountCampaignBanner"
      );
    },
    exact: true,
  },
  {
    path: "/manage/discount/campaign-banner/add",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AddDiscountCampaignBanner />,
        "AddDiscountCampaignBanner"
      );
    },
    exact: true,
  },
  {
    path: "/manage/discount/campaign-banner/edit/:id",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <EditDiscountCampaignBanner />,
        "EditDiscountCampaignBanner"
      );
    },
    exact: true,
  },
  {
    path: "/manage/discount/campaign-banner/view/:id",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <ViewDiscountCampaignBanner />,
        "ViewDiscountCampaignBanner"
      );
    },
    exact: true,
  },
  {
    path: "/manage/discount/select-position-banner",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <SelectPositionBanner />,
        "SelectPositionBanner"
      );
    },
    exact: true,
  },
  {
    path: "/manage/discount/add-position-banner/:id",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AddDiscountToPositionBanner />,
        "AddDiscountToPositionBanner"
      );
    },
    exact: true,
  },
  {
    path: "/manage/discount/edit-position-banner/:id/position-tag-html-id/:positionTagHtmlID",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <EditDiscountToPositionBanner />,
        "EditDiscountToPositionBanner"
      );
    },
    exact: true,
  },
];

export default discountRoutes;
